// extracted by mini-css-extract-plugin
module.exports = {"Root":"Map_Root__2m_LF","Map":"Map_Map__wDvk0","OpenButton":"Map_OpenButton__ls0Xs","CloseButton":"Map_CloseButton__3fmcu","IsOpenedMap":"Map_IsOpenedMap__hMF21"};